export const fadeAnimationName = `@keyframes fadeIn: {
  from: { opacity: 0 },
  to: { opacity: 1 },
}`;

export const fadeAnimation = 'fadeIn 1s linear forwards';
